import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EssentialService } from '../../services/essential.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
})
export class BreadcrumbComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;

  public breadcrumList: any = [];

  constructor(private route: ActivatedRoute, private router: Router, private essentialsService: EssentialService) { }

  public ngOnInit() {
    this.GetCategoryMenus(this.settings.selectedCategory);
  }

  GetCategoryMenus(id) {

    if (!id) {
      this.breadcrumList = [];
      return;
    }
    if (this.data.dataChashingService && this.data.dataChashingService.menusCategories[id]) {
      let menu = this.data.dataChashingService.menusCategories[id];
      this.breadcrumList = this.getBreadcrumb(menu)
    } else
      this.essentialsService.getCategoryMenus(id).subscribe((res: any) => {
        this.data.dataChashingService.menusCategories[id] = res;
        let menu = res;
        this.breadcrumList = this.getBreadcrumb(menu)
      });
  }




  public getBreadcrumb(menu) {
    var data = this.route.snapshot.data;
    var id = data['id'];
    var type = data['type'];
    var slug = data['slug'];

    const res = this.findMenuPath(menu, type, id, slug);
    if (res.length)
      return res

    return [];
  }


  findMenuPath(menus, type, id, slug) {
    var array = []
    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
      if ((type == 1 && menu.type == 2 && menu.pageId == id) || (type == 2 && menu.type == 6 && menu.slug == slug)) {
        array.push(menu)
        return array
      } else if (menu.childs && menu.childs.length) {
        const list = this.findMenuPath(menu.childs, type, id, slug)
        if (list.length) {
          array.push(menu)
          array = array.concat(this.findMenuPath(menu.childs, type, id, slug))
        }
      }
    }
    return array
  }




  public navigateTo(slug, el) {
    if (!el) {
      this.router.navigate([slug]);
    }
    if (el && slug) {
      this.router.navigate([slug]);
      setTimeout(() => {
        const elmnt = document.getElementById(el);
        if (elmnt && elmnt != null) {
          elmnt.scrollIntoView();
        }
      }, 200);
    }
  }



}
